import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../Sidebar";
import OrderBox from "./OrderBox";
import {
  BsFillPatchCheckFill,
  BsCartCheckFill,
  BsFillExclamationDiamondFill,
  BsFillCartXFill,
} from "react-icons/bs";
import PendingStatsTable from "./PendingStatusTable";
import { SERVER_PATH } from "../../config/env";
import { OrderDataTable } from "./OrderDataTable";
import { successToaster } from "./../../utils/index";
import { ToastContainer } from "react-toastify";
import { Breadcrumbs } from "./../Breadcrumb/index";
import apiClient from "../../utils/api";

export default function OrderList() {
  const [toggleState, setToggleState] = useState("pendingOrders");
  // const [selectOption, setSelectOption] = useState("select");
  const [data, setData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [confirmData, setConfirmData] = useState([]);
  const [cancelData, setCancelData] = useState([]);
  const [selectStatus, setSelectStatus] = useState({ option: "" });

  const toggleClick = (clickState) => {
    setToggleState(clickState);
  };

  const fetchData = async () => {
    await apiClient
      .post(`get/order.php`, {})
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const pendingOrder = async () => {
    await apiClient
      .post(`get/order.php`, {
        status: "pending",
      })
      .then((res) => {
        setPendingData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const confirmOrder = async () => {
    await apiClient
      .post(`get/order.php`, {
        status: "confirm",
      })
      .then((res) => {
        setConfirmData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const cancelOrder = async () => {
    await apiClient
      .post(`get/order.php`, {
        status: "cancel",
      })
      .then((res) => {
        setCancelData(res.data);
        console.log(res.data)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (e) => {
    setSelectStatus(e.target.value);
  };

  const updateStatus = async (orderID, userID, productID, qty) => {
    await apiClient
      .post(`put/order.php`, {
        order_id: orderID,
        user_id: userID,
        product_id: productID,
        quantity: qty,
        status: selectStatus,
      })
      .then((res) => {
        successToaster({ msg: "Status Updated" });
        pendingOrder();
      });
  };

  useEffect(() => {
    pendingOrder();
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <Sidebar />
          <Col lg={10} style={{ backgroundColor: "#f1f2f3" }} className="pt-3">
            <Breadcrumbs currentPathName="Order Details" />
            <Row className="g-4 p-4">
              <OrderBox
                toggleState={() => {
                  toggleClick("totalOrders");
                  fetchData();
                }}
                styleName="totalOrderBox"
                title="Total Orders"
                icons={<BsCartCheckFill />}
              />
              <OrderBox
                toggleState={() => {
                  toggleClick("confirmOrders");
                  confirmOrder();
                }}
                styleName="confirmOrderBox"
                title="Confirm Orders"
                icons={<BsFillPatchCheckFill />}
              />
              <OrderBox
                toggleState={() => {
                  toggleClick("pendingOrders");
                  pendingOrder();
                }}
                styleName="pendingOrderBox"
                title="Pending Orders"
                icons={<BsFillExclamationDiamondFill />}
              />
              <OrderBox
                toggleState={() => {
                  toggleClick("cancelOrders");
                  cancelOrder();
                }}
                styleName="cancelOrderBox"
                title="Cancelled Orders"
                icons={<BsFillCartXFill />}
              />
            </Row>
            {/* <Row>
              <Col className="orderFilterDiv">
                <Row>
                  <Col
                    lg={4}
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "120px" }}>
                    <div>
                      <label>search by filter</label>
                      <select
                        className="form-select"
                        name=""
                        id=""
                        onChange={(e) => {
                          const selectedOption = e.target.value;
                          setSelectOption(selectedOption);
                        }}>
                        <option value="select">Select any one</option>
                        <option value="year">year</option>
                        <option value="month">month</option>
                        <option value="date">date</option>
                        <option value="orderId">order id</option>
                      </select>
                    </div>
                  </Col>
                  <Col lg={6}>
                    {selectOption === "select" ? (
                      <div
                        className="d-flex align-items-center"
                        style={{ height: "120px" }}>
                        <div>
                          <label>Select anyone option by filter</label>
                          <input
                            type="number"
                            placeholder="ENTER PRODUCT ID"
                            className="px-2 py-1"
                          />
                          &nbsp;
                          <button
                            className="btn btn-outline-primary text-uppercase"
                            style={{ marginTop: "-5px" }}>
                            submit
                          </button>
                        </div>
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </Col>
            </Row> */}
            <Row className="px-4">
              <Col className="orderTableDiv">
                {toggleState === "totalOrders" ? (
                  <OrderDataTable
                    tableStyle={{
                      backgroundColor: "#0984e3",
                      color: "#fff",
                      fontSize: ".9em",
                    }}
                    tableData={data}
                  />
                ) : toggleState === "confirmOrders" ? (
                  <OrderDataTable
                    tableStyle={{
                      backgroundColor: "#2ecc71",
                      color: "#fff",
                      fontSize: ".9em",
                    }}
                    tableData={confirmData}
                  />
                ) : toggleState === "pendingOrders" ? (
                  <PendingStatsTable
                    tableStyle={{
                      backgroundColor: "#f39c12",
                      color: "#fff",
                      fontSize: ".9em",
                    }}
                    tableData={pendingData}
                    handleChange={handleChange}
                    statusSubmit={updateStatus}
                  />
                ) : toggleState === "cancelOrders" ? (
                  <OrderDataTable
                    tableStyle={{
                      backgroundColor: "#c0392b",
                      color: "#fff",
                      fontSize: ".9em",
                    }}
                    tableData={cancelData}
                  />
                ) : null}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </>
  );
}
